module.exports = __webpack_public_path__ + "img/trust-hero.c250bc68.svg";